import { ReactElement } from 'react';

import { TeamMembers } from '../../../pages/about';
import { Hero } from './components/hero';
import { Join } from './components/join';
import { Statements } from './components/statements';
import { Team } from './components/team';
import * as S from './PageContent.styles';

type Props = {
  teamMembers: TeamMembers;
};

export const AboutPageContent = (props: Props): ReactElement => {
  return (
    <S.Wrapper>
      <Hero />
      <Statements />
      <Team teamMembers={props.teamMembers} />
      <Join />
    </S.Wrapper>
  );
};
